import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { supabase } from '../webSupabaseClient';

function ForgotPasswordForm({ setView }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handlePasswordResetRequest = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // DÜZELTME: Yönlendirme adresini yeni oluşturduğumuz sayfa olarak değiştiriyoruz.
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/update-password`, 
      });

      if (error) throw error;
      toast.success('Şifre sıfırlama talimatları e-posta adresinize gönderildi. Lütfen gelen kutunuzu kontrol edin.');
      // Kullanıcıyı hemen giriş ekranına döndürmek yerine e-postasını kontrol etmeye teşvik ediyoruz.
    } catch (error) {
      toast.error(error.message || 'Bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="animate-fade-in">
      <h3 className="text-xl font-bold text-center mb-4 text-text-dark">Şifremi Unuttum</h3>
      <p className="text-center text-sm text-gray-600 mb-6">
        Hesabınıza kayıtlı e-posta adresini girin, size şifre sıfırlama linki gönderelim.
      </p>
      <form onSubmit={handlePasswordResetRequest} className="space-y-4">
        <div>
          <label htmlFor="reset-email" className="sr-only">E-posta</label>
          <input
            id="reset-email"
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            placeholder="E-posta adresiniz"
            className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-brand-green focus:border-brand-green"
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-brand-green hover:bg-brand-green-light text-white font-bold py-3 rounded-md transition-colors disabled:opacity-50"
        >
          {loading ? 'Gönderiliyor...' : 'Sıfırlama Linki Gönder'}
        </button>
        <button
          type="button"
          onClick={() => setView('login')}
          className="w-full mt-2 text-center text-sm text-gray-600 hover:text-brand-green"
        >
          Giriş Yap ekranına geri dön
        </button>
      </form>
    </div>
  );
}

export default ForgotPasswordForm;